import React from "react";
import CustomModal from "./components/CustomModal";
import CustomModalSetting from "./components/CustomModalSetting";
import { ReactComponent as PluginSvg } from "@assets/icons/input_setting.svg";
import { getLocale } from '@utils/util';
import { createForm, createRow, createColumn } from "@whalecloud/page-builder-core/utils/elementUtils";
import { ElementGroup } from '@whalecloud/page-builder-core/constant';


const createChildren = () => {
  return [createForm({
    elements: [createRow({ elements: [createColumn()] })]
  })]
}

export default () => {
  const messages = getLocale();
  return {
    name: 'custommodal', // 插件名，不能包含空格,空格用-代替
    group: ElementGroup.TEMPLATE,
    // target: ["column", "row", "form"], // 插件所在目标层级，默认为["column", "row", "form"]
    title: messages['PAGEBUIDER_ELEMENT_FORM_CUSTOM_MODAL'], // 插件标题
    toolBarPreview: <PluginSvg />, // 插件展示图标，不传则展示文字
    data: { // 插件初始化数据
      settings: {
        width: {
          value: "100%"
        },
      }, // 插件样式属性
      formItemSettings: {
        allowClear: true,
        bordered: true,
        mask: false,
     
      },
      formSettings: {
        label: messages['PAGEBUIDER_ELEMENT_FORM_CUSTOM_MODAL'],
      },
    },
    elements: createChildren,
    pluginComponent: CustomModal, // 插件渲染组件
    pluginSettingComponent: CustomModalSetting, // 插件设置项组件
  }
}
